<template>
	<div class="image-preview-wrapper">
		<span
			class="large-button mini no-margin"
			@click="$emit('show-uploader')"
			v-html="!!value && !!value.thumbnail ? 'Change Image' : 'Select Image'"
		/>
		<div class="image-preview-container" v-if="!!value && !!value.thumbnail">
			<img :src="value.thumbnail" alt="" class="logo-preview" />
			<span class="delete-image" @click="$emit('delete-image')">X</span>
		</div>

		<p class="image-info"><slot /></p>
	</div>
</template>

<script>
export default {
	name: "ImagePreview",
	props: {
		value: {
			type: Object,
			default: null,
		},
	},
};
</script>

<style lang="less" scoped>
@import "../../assets/css/less/_settings.less";
.image-preview-wrapper {
	
	.image-info {
		margin: 30px 0 0;
	}

	.image-preview-container {
		position: relative;
		display: inline-block;
		margin-left: 10px;
		.logo-preview {
			max-width: 200px;
			max-height: 100px;
			height: auto;
		}

		.delete-image {
			background-color: @red;
			color: white;
			cursor: pointer;
			position: absolute;
			right: 5px;
			top: 5px;
			padding: 2px 0 0;
			border-radius: 50%;
			font-size: 12px;
			width: 20px;
			height: 20px;
			text-align: center;
		}
	}
}
</style>
